
import {
    SEARCH_IMMUNIZATIONS_REQUEST,
    SEARCH_IMMUNIZATIONS_SUCCESS,
    SEARCH_IMMUNIZATIONS_FAILURE,
    ADD_IMMUNIZATION_REQUEST,
    ADD_IMMUNIZATION_SUCCESS,
    ADD_IMMUNIZATION_FAILURE,
    EDIT_IMMUNIZATION_REQUEST,
    EDIT_IMMUNIZATION_SUCCESS,
    EDIT_IMMUNIZATION_FAILURE,
    VIEW_IMMUNIZATION_REQUEST,
    VIEW_IMMUNIZATION_SUCCESS,
    VIEW_IMMUNIZATION_FAILURE,
    INITIALIZE_NEW_IMMUNIZATION,
    ADD_EDIT_IMMUNIZATION_VIEW,
    CANCEL_IMMUNIZATION_FORM,
    SEARCH_IMMUNIZATIONS_VIEW

} from '../healthRecordActionTypes';
 
// Reducers
const initialState = {
    loading: false,
    immunizations: [],
    error: '',

    immunization: {
        studentId: null,
        firstName:"",
        lastName:"",
        immunizationRecordsId: null,
        exemptedFromAllVaccines:"",
        immunizations: [
            {
                vaccine:"",
                allowExemption:"",
                exemptionDate:"",
                lotNumber:"",
                dosage:"",
                immunizationRecordsId:null,
                immunizationId:null
            }
        ]
    },
    activeView: SEARCH_IMMUNIZATIONS_VIEW,
    urlPath:'/student-life/health-record/immunizations'

};

const immunizationReducer = (state = initialState, { type, payload}) => {
    switch (type) {

        // Immunization Actions
        case SEARCH_IMMUNIZATIONS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case ADD_IMMUNIZATION_REQUEST:
        case EDIT_IMMUNIZATION_REQUEST:
        case VIEW_IMMUNIZATION_REQUEST:
            return {
                ...state,
                loading: true
            };
        case SEARCH_IMMUNIZATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                immunizations: payload,
                error: ''
            };
        case ADD_IMMUNIZATION_SUCCESS:
        case EDIT_IMMUNIZATION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: ''
            };
        case VIEW_IMMUNIZATION_SUCCESS:
            return {
                ...state,
                loading: false,
                immunization: payload,
                activeView: ADD_EDIT_IMMUNIZATION_VIEW,
                urlPath: `/student-life/health-record/immunizations/edit/${payload.studentId}`,
                error: ''
            };
        case SEARCH_IMMUNIZATIONS_FAILURE:
        case ADD_IMMUNIZATION_FAILURE:
        case EDIT_IMMUNIZATION_FAILURE:
        case VIEW_IMMUNIZATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case INITIALIZE_NEW_IMMUNIZATION:
            return {
                ...state,
                immunization: initialState.immunization,
                activeView: ADD_EDIT_IMMUNIZATION_VIEW
            };
        case CANCEL_IMMUNIZATION_FORM:{
            return {
                ...state,
                activeView: SEARCH_IMMUNIZATIONS_VIEW,
                urlPath:'/student-life/health-record/immunizations'
            };
        }
        default:
            return state;
    }
};

export default immunizationReducer;